export default __webpack_public_path__ + "static/media/RamLight.fed1425d.png";